import { render } from "./topThisWeek.vue?vue&type=template&id=2949ee5f"
import script from "./topThisWeek.vue?vue&type=script&lang=js"
export * from "./topThisWeek.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__